<h2 class="sr-only">{{ "SchnellSuche" | translate }}</h2>

<form (ngSubmit)="onSubmit()" #form="ngForm">
  <div class="row">
    <div class="col-md-6 col-xs-12 bsg-input-wrapper mb-500">
      <cap-form-row>
        <div class="input-group">
          <input
            (selectItem)="onSelected($event)"
            [(ngModel)]="model"
            [inputFormatter]="inputFormatter"
            [ngbTypeahead]="search"
            [placeholder]="'searchperson.placeholderText' | translate"
            [resultFormatter]="resultFormatter"
            class="form-control"
            id="personGbInput"
            name="personGbInput"
            style="width: 80%"
            type="search" />
          @if (showNoResultText && !isSearching) {
            <div class="dropdown-menu show dropdown-message">
              <button class="dropdown-item">{{ "searchperson.noResults" | translate }}</button>
            </div>
          }
          @if (isSearching) {
            <div class="dropdown-menu show dropdown-message">
              <button class="dropdown-item">{{ "searchperson.searchingText" | translate }}</button>
            </div>
          }
          <span
            [ngbPopover]="searchDescription"
            [placement]="['right', 'bottom', 'auto']"
            class="input-group-text"
            popoverClass="custom-popover"
            triggers="mouseenter"
            ><i class="fa-info-circle fa"></i
          ></span>
        </div>
      </cap-form-row>
    </div>
  </div>
  <button style="display: none" type="submit">hidden submit</button>
</form>

<ng-template #searchDescription class="search-description-popover" id="search-description-popover">
  <p>{{ "schnellsuche.help.suche" | translate }}</p>
  <p>{{ "schnellsuche.help.fuzzy" | translate }}</p>
  <p>{{ "schnellsuche.help.attributes" | translate }}</p>
  <ul>
    <li>{{ "Vorname" | translate }}</li>
    <li>{{ "Name" | translate }}</li>
    <li>{{ "Ledigname" | translate }}</li>
    <li>{{ "Geburtsdatum" | translate }}</li>
    <li>{{ "Adresse" | translate }}</li>
    <li>{{ "AHVVersichertennummer" | translate }}</li>
    <li>{{ "UID" | translate }}</li>
    <li>{{ "schnellsuche.help.city" | translate }}</li>
  </ul>
  <p>{{ "schnellsuche.help.order" | translate }}</p>
  <p>{{ "schnellsuche.help.exact" | translate }}</p>
  <ul>
    <li>{{ "Vorname" | translate }}</li>
    <li>{{ "Name" | translate }}</li>
    <li>{{ "Ledigname" | translate }}</li>
    <li>{{ "Adresse" | translate }}</li>
    <li>{{ "Strasse" | translate }}</li>
    <li>{{ "Ort" | translate }}</li>
  </ul>
  <p>{{ "schnellsuche.help.exact.addition" | translate }}</p>
</ng-template>
